import React, { useEffect } from 'react'
import { useFlags } from 'shared/components/common/FlagsProvider'
import BasePage from 'src/components/layouts/BasePage'
import DocumentTitle from 'src/components/common/DocumentTitle'
import { Card, makeStyles } from '@material-ui/core'
import EventsView from './EventsView'
import type { Theme } from '@material-ui/core/styles'
import CRMPromptPage from 'src/components/layouts/CRMPromptPage'
import CRMPromptCalendarShim from 'src/components/common/Calendar/CRMPromptCalendarShim'
import { useNavContext } from 'src/components/common/Header/SideNav'

const useStyles = makeStyles<Theme>((_theme) => ({
  section: {
    marginTop: 3
  }
}))

export default function Events() {
  const { crm: crmFlag } = useFlags()
  const classes = useStyles()
  const { setPageSubtitle } = useNavContext()

  useEffect(() => {
    setPageSubtitle('Sales')

    return () => {
      setPageSubtitle('')
    }
  }, [])

  return (
    <BasePage>
      <DocumentTitle title="Events" />
      {crmFlag ? (
        <div className={classes.section}>
          <EventsView />
        </div>
      ) : (
        <CRMPromptPage
          Background={
            <Card>
              <CRMPromptCalendarShim />
            </Card>
          }
        />
      )}
    </BasePage>
  )
}
